import { FieldId } from '../../gk-dynamic-list/services/dictionary/dictionary.model';
import { DistrictGusField } from '../district-gus-dictionary/district-gus-dictionary.model';

export class CommunityGusDictionaryRequestBody {
  constructor(
    public WojewId: string | number,
    public PowiatId: string | number,
  ) {}

  static fromDistrictGus(
    data: DistrictGusField,
  ): CommunityGusDictionaryRequestBody {
    return new this(data.voivodeshipId, data.id);
  }

  getCacheKey(): string {
    return `${this.WojewId}-${this.PowiatId}`;
  }
}

export class CommunityGusFieldFromApi {
  constructor(
    public GminaId: FieldId,
    public GminaNrGus: string,
    public Nazwa: string,
    public PowiatId: FieldId,
    public RodzajGminaId: FieldId,
    public RodzajNazwa: string,
    public WojewId: FieldId,
  ) {}
}

export class CommunityGusField {
  constructor(
    public id: FieldId,
    public gusNumber: string,
    public name: string,
    public displayName: string,
    public typeId: FieldId,
    public typeName: string,
    public districtId: FieldId,
    public voivodeshipId: FieldId,
  ) {}

  static fromApiToApp(
    fieldFromApi: CommunityGusFieldFromApi,
  ): CommunityGusField {
    return new this(
      fieldFromApi.GminaId,
      fieldFromApi.GminaNrGus,
      fieldFromApi.Nazwa,
      `${fieldFromApi.Nazwa} [${fieldFromApi.RodzajNazwa}]`,
      fieldFromApi.RodzajGminaId,
      fieldFromApi.RodzajNazwa,
      fieldFromApi.PowiatId,
      fieldFromApi.WojewId,
    );
  }
}
